import { useState } from 'react';
import './CollapseInfo.scss';
import classnames from 'classnames';

export const CollapseInfo = props => {
  const {
    title,
    context,
    iconUp,
    iconDown,
    divider,
    removePadding,
    removecollapsible,
    onToggleCallBack,
    className,
    classNameToArrow,
    removeJustifyStart,
  } = props;
  const [opened, setOpened] = useState(false);

  const toggle = e => {
    e.preventDefault();
    setOpened(!opened);
    if (onToggleCallBack) {
      onToggleCallBack();
    }
  };

  const handleEnterKeyPress = event => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      toggle(event);
    }
  };

  const collapsibleContainer = classnames(
    'padTB20 flex-container items-align-center collapsibleContainer',
    classNameToArrow,
    {
      collapsible: !removecollapsible,
      padL18: !removePadding,
      'justify-start': !removeJustifyStart,
    },
  );

  const contentStyle = classnames('content', {
    padL18: !removePadding,
  });

  return (
    <div className={`collapseInfo ${className}`}>
      <div
        className={collapsibleContainer}
        onClick={toggle}
        onKeyDown={handleEnterKeyPress}
        tabIndex={'0'}
        role="region"
      >
        {title}
        {opened ? iconUp : iconDown}
      </div>
      <div
        className="format100 flex-container items-align-center justify-center"
        style={{ display: opened ? 'flex' : 'none' }}
      >
        {divider}
      </div>
      <div
        className={contentStyle}
        style={{ display: opened ? 'block' : 'none' }}
      >
        {context}
      </div>
    </div>
  );
};
